import { render, staticRenderFns } from "./book.vue?vue&type=template&id=6245653e&scoped=true&"
import script from "./book.vue?vue&type=script&lang=js&"
export * from "./book.vue?vue&type=script&lang=js&"
import style0 from "./book.vue?vue&type=style&index=0&id=6245653e&scoped=true&lang=scss&"
import style1 from "./book.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6245653e",
  null
  
)

component.options.__file = "book.vue"
export default component.exports